module.exports = __webpack_public_path__ + "img/illustrate04.102c0173.png";